import { Component, inject } from '@angular/core';

import { AnchorDirective, CurrencyPipe } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';

import { MessageType } from '../../../../model/message.model';
import { OptionListService } from '../../../../service/optionList.service';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-rev-notification',
    templateUrl: 'reversal-notification.component.html',
    imports: [MessageComponent, TranslateModule, CurrencyPipe, AnchorDirective],
})
export class ReversalNotificationComponent {
    private optionListService = inject(OptionListService);

    reversalArr: any[];
    reversalExists: boolean;
    totalReversals: { amount: number; code: string };

    constructor() {
        const optionListService = this.optionListService;

        this.reversalArr = optionListService?.reversalArr;
        this.reversalExists = this.optionListService?.reversalExists;
        this.totalReversals = {
            amount: this.getSumOfAllReversals() || 0,
            code: this.reversalArr?.[0]?.redeemAmount?.currencyCode || '',
        };
    }

    public get messageType(): typeof MessageType {
        return MessageType;
    }

    gotoWithdrawal() {
        this.optionListService.redirectToMainCashier('&type=reverse-withdrawal');
    }

    getSumOfAllReversals() {
        let sum = 0;
        if (!this.reversalArr?.length) {
            return sum;
        }
        sum = this.reversalArr.reduce((total, item) => total + parseFloat(item?.redeemAmount?.value || 0), 0);

        return +sum.toFixed(2);
    }
}
